import React from 'react';

interface BouncingDotsLoaderProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
}

const sizeConfig = {
  sm: {
    wrapper: 'w-[140px] h-[12px]',
    loaderSize: 'shadow-rolling-sm',
  },
  md: {
    wrapper: 'w-[180px] h-[15px]',
    loaderSize: 'shadow-rolling-md',
  },
  lg: {
    wrapper: 'w-[220px] h-[18px]',
    loaderSize: 'shadow-rolling-lg',
  },
};

export function BouncingDotsLoader({
  size = 'lg',
  color = 'bg-primary-500',
  className = ''
}: BouncingDotsLoaderProps) {
  const config = sizeConfig[size];

  const colorMap: { [key: string]: string } = {
    'bg-primary-500': '#3E8B82',
    'bg-emerald-500': '#10b981',
    'bg-blue-500': '#3b82f6',
    'bg-red-500': '#ef4444',
    'bg-yellow-500': '#eab308',
    'bg-purple-500': '#a855f7',
    'bg-green-500': '#22c55e',
  };

  const hexColor = colorMap[color] || '#3E8B82';

  return (
    <div className={`relative ${config.wrapper} flex items-center justify-center ${className}`}>
      <div
        className={`shadow-rolling-loader ${config.loaderSize}`}
        style={{
          '--ball-color': hexColor,
        } as React.CSSProperties}
      />
    </div>
  );
}
